import { render } from "./TestPageMenu.vue?vue&type=template&id=dc93b2c4"
import script from "./TestPageMenu.vue?vue&type=script&lang=js"
export * from "./TestPageMenu.vue?vue&type=script&lang=js"

import "./TestPageMenu.vue?vue&type=style&index=0&id=dc93b2c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__